import _ from 'lodash';


export class KendoGridHelper {
    constructor(e) {
        let grid = e;

        // Account for passing in an event argument instead of the actual grid instance
        if (e.sender) grid = e.sender;

        this.grid = grid;
        this.dataSource = this.grid.dataSource;
    }

    getTableRows() {
        return this.grid.items();
    }

    getItem(tr) {
        const item = this.grid.dataItem(tr);
        if (item) return this.sanitizeItem(item);
        return undefined;
    }

    getSelectedItems() {
        const selectedRows = this.grid.select();
        var items = [];

        for (let i = 0; i < selectedRows.length; i++) {
            const item = this.grid.dataItem(selectedRows[i]);
            items.push(item);
        }

        const sanitizedItems = _.map(items, (i) => this.sanitizeItem(i));

        return sanitizedItems;
    }

    deselectItems() {
        this.grid.clearSelection();
    }

    refresh() {
        this.grid.dataSource.read();
    }

    sanitizeItem(item) {
        const result = _.cloneDeep(item);

        // Remove the Kendo-injected properties
        delete result.dirty;
        delete result.dirtyFields;
        delete result.parent;
        delete result._events;
        delete result._handlers;

        return result;
    }
}

export default KendoGridHelper;
